import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/prism';
import { oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { CodeDisplayProps } from '../props';
import { ContentWrapper } from './content-wrapper';

export function CodeDisplay({
    code,
    language = 'sql',
    title = `View ${language.toUpperCase()}`,
    collapsible = true,
    className = '',
}: CodeDisplayProps) {
    const content = (
        <SyntaxHighlighter
            style={oneLight}
            language={language}
            PreTag="div"
            className={`overflow-x-scroll text-mini ${className}`}
        >
            {code}
        </SyntaxHighlighter>
    );

    return (
        <ContentWrapper>
            {collapsible ? (
                <details>
                    <summary className="text-mini text-foreground/70">{title}</summary>
                    {content}
                </details>
            ) : (
                <div>
                    {title && <div className="mb-2 text-mini text-foreground/70">{title}</div>}
                    {content}
                </div>
            )}
        </ContentWrapper>
    );
}
